import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { resetStore } from "src/store/actions";
import { sortList } from "src/utils/genericFunctions";
import {
  getStoreGroupMultiSelectFilter,
  getFlashHierarchyFilterData
} from "../../../api/bi/index";

export const flashHierarchyFilterData = createAsyncThunk(
  "/report/flashHierarchyFilter",
  () => getFlashHierarchyFilterData()
);
export const flashMultiselect = createAsyncThunk(
  "/report/flashMultiselect",
  () => getStoreGroupMultiSelectFilter()
);

const initialState: any = {
  storeCategory: {
    data: []
  },
  region: {
    data: []
  },
  dsmVP: {
    data: []
  },
  seniorDSM: {
    data: []
  },
  dsm: {
    data: []
  },
  status: "initial",
  error: null
};

const flashSalesFilterSlice = createSlice({
  name: "flashSalesFilter",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(flashMultiselect.pending, (state) => {
        state.status = "pending";
      })
      .addCase(flashMultiselect.fulfilled, (state, { payload }) => {
        state.status = "idle";
        state.region.data = payload.data.region;
        state.storeCategory.data =
          payload.data.storeCategory.map(mapFilterData);
      })
      .addCase(flashMultiselect.rejected, (state, _action) => {
        state.status = "error";
        state.storeCategory.data = [];
        state.region.data = [];
      })

      .addCase(flashHierarchyFilterData.pending, (state) => {
        state.status = "pending";
      })
      .addCase(flashHierarchyFilterData.fulfilled, (state, { payload }) => {
        state.status = "idle";
        const { dsmVp, seniorDSM, dsm } = mapDsmVpFilterData(payload.data);
        state.dsmVP.data = sortList(dsmVp, "name");
        state.seniorDSM.data = sortList(seniorDSM, "name");
        state.dsm.data = sortList(dsm, "name");
      })
      .addCase(flashHierarchyFilterData.rejected, (state, _action) => {
        state.status = "error";
        state.dsmVP.data = [];
        state.seniorDSM.data = [];
        state.dsm.data = [];
      });
  }
});

function mapFilterData(data: any) {
  return {
    id: data,
    name: data
  };
}
export function mapDsmVpFilterData(filterData: any) {
  const dsmVp: any = [];
  const seniorDSM: any = [];
  const dsm: any = [];
  filterData.forEach((dsmVpData: any) => {
    dsmVp.push({
      id: dsmVpData.regionVP,
      name: dsmVpData.regionVP
    });
    dsmVpData.regionSeniorDSM.forEach((seniorData: any) => {
      seniorDSM.push({
        id: seniorData.regionSeniorDSM,
        name: seniorData.regionSeniorDSM,
        dsmVpId: dsmVpData.regionVP
      });
      seniorData.dsm.forEach((dsmData: any) => {
        dsm.push({
          ...dsmData,
          seniorDsmId: seniorData.regionSeniorDSM,
          dsmVpId: dsmVpData.regionVP
        });
      });
    });
  });
  return { dsmVp, seniorDSM, dsm };
}

export default flashSalesFilterSlice.reducer;
